/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RestockTable.vue?vue&type=template&id=355021c8"
import script from "./RestockTable.vue?vue&type=script&lang=js"
export * from "./RestockTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355021c8')) {
      api.createRecord('355021c8', component.options)
    } else {
      api.reload('355021c8', component.options)
    }
    module.hot.accept("./RestockTable.vue?vue&type=template&id=355021c8", function () {
      api.rerender('355021c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/inventory/RestockTable.vue"
export default component.exports